/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import TextAnim from '~/components/TextAnim';
import revealFx from '~/effects/reveal';

export const Cover = React.forwardRef(({
	className,
	classes,
	progress,
	assets,
	mobile,
	noiseWidth,
	smoothMask,
	onLoadStart,
	onLoadError,
	onLoadProgress,
	onLoadComplete,
	...props
}, ref) => {
	const rootRef = React.useRef();
	const figureRef = React.useRef();
	const titleRef = React.useRef();
	const reveal = React.useRef();
	const [lastIndex, setLastIndex] = React.useState(0);
	const [currentIndex, setCurrentIndex] = React.useState(0);

	const jump = React.useCallback((step) => {
		setLastIndex(currentIndex);
		if (currentIndex > assets.length - 1) {
			setCurrentIndex(0);
		} else {
			setCurrentIndex((currentIndex + step) % assets.length);
		}
	}, [lastIndex, currentIndex]);

	const next = React.useCallback(() => jump(+1), [lastIndex, currentIndex]);
	const prev = React.useCallback(() => jump(-1), [lastIndex, currentIndex]);
	const resize = () => {
		if (reveal.current) {
			if (reveal.current.textures.length) {
				if (reveal.current.textures[0].image) {
					reveal.current.resize();
				}
			}
		}
	};

	const setProgress = (progress, time = 1) => {
		if (reveal.current) {
			reveal.current.setProgress(progress, time);
		}
	};

	const dispose = () => {
		if (reveal.current) reveal.current.dispose(true);
	};

	const createView = () => {
		reveal.current = revealFx({
			stageElement: rootRef.current,
			sceneElement: figureRef.current,
			imageList: assets,
			noiseWidth,
			smoothMask,
			onLoadStart,
			onLoadError,
			onLoadProgress,
			onLoadComplete,
			progress,
			mobile,
		});
		return dispose;
	};

	React.useImperativeHandle(ref, () => ({
		root: rootRef.current,
		figure: figureRef.current,
		title: titleRef.current,
		setProgress,
		dispose,
		resize,
		jump,
		next,
		prev,
	}));

	React.useEffect(createView, [mobile]);
	React.useEffect(() => setProgress(progress), [progress]);
	return (
		<section className={cls(classes.root, className)} ref={rootRef}>
			<figure className={cls(classes.figure)} ref={figureRef}/>
			<header className={cls(classes.header)} ref={titleRef}>
			
				<h1 className={cls(classes.headerTitle)}>Reinvente<br/>a diversão</h1>
				<h2 className={cls(classes.headerSubtitle)} dangerouslySetInnerHTML={{
					__html: assets[currentIndex].caption,
				}}/>
			</header>
		</section>
	);
});

export default React.memo(Cover);
